import React from 'react';
import BaseSkeleton from './base-skeleton';

interface SkeletonTextProps {
  lines?: number;
  spacing?: string;
  lastLineWidth?: string;
  className?: string;
}

const SkeletonText: React.FC<SkeletonTextProps> = ({
  lines = 3,
  spacing = 'space-y-2',
  lastLineWidth = '75%',
  className = '',
}) => {
  return (
    <div className={`${spacing} ${className}`}>
      {Array.from({ length: lines }).map((_, index) => (
        <BaseSkeleton
          key={index}
          variant="text"
          height="1em"
          width={index === lines - 1 ? lastLineWidth : '100%'}
        />
      ))}
    </div>
  );
};

export default SkeletonText;